export const environment = {
  production: false,
  chatbotUrl: "https://stage.bot.wizefulfill.com/",
  baseUrl: "https://api.feature-setup-report-ai.wizefulfill.com/",
  sellerCloudUrl: "https://shtiks.api.sellercloud.com/rest/api/",
  authServiceUrl: "https://api.feature-setup-report-ai.wizefulfill.com/auth_service",
  clientServiceUrl: "https://api.feature-setup-report-ai.wizefulfill.com/client_service",
  spServiceUrl: "https://api.feature-setup-report-ai.wizefulfill.com/wms_service",

  // authServiceUrl: 'http://localhost:3000',
  // clientServiceUrl: 'http://localhost:3001',
  // spServiceUrl: 'http://localhost:3001',

  
  hubspot: {
    portalId: "45268756",
    hublet: "na1",
    environment: "prod",
    defaultChatFlow: "mobilechat",
  }
};